import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { CartModel } from "@insite/client-framework/Types/ApiModels";
import {
    DiscrepancyCollectionParam,
    DiscrepancyCollectionResult,
    DiscrepancyDetailsResult,
} from "@tKgpco/Services/DiscrepancyService";
import { MessageCollectionModel } from "@tKgpco/Services/LoadMessageCollection";
import { RMACollectionParam, RMACollectionResult, RMADetailsResult } from "@tKgpco/Services/RMAService";
import { DiscrepancyHistoryState } from "@tKgpco/Store/Data/DiscrepancyHistory/DiscrepancyState";
import { RMAHistoryState } from "@tKgpco/Store/Data/RMA/RMAState";
import { Draft } from "immer";

const initialState: RMAHistoryState = {
    isLoading: false,
    RMACollection: null,
    RMACollectionParams: {
        page: 1,
    },
    isFilterOpen: false,
    RMACollectionDetails: null,
    RMACollectionMessages: null,
};

const reducer = {
    "Custom/RMA/BeginLoadRMACollection": (draft: Draft<RMAHistoryState>, action: { params: RMACollectionParam }) => {
        draft.isLoading = true;
        draft.RMACollectionParams = action.params;
        draft.RMACollection = null;
    },

    "Custom/RMA/CompleteLoadRMACollection": (
        draft: Draft<RMAHistoryState>,
        action: { result: RMACollectionResult },
    ) => {
        draft.isLoading = false;
        draft.RMACollection = action.result;
    },
    "Custom/RMA/ToggleFiltersOpen": (draft: Draft<RMAHistoryState>) => {
        draft.isFilterOpen = !draft.isFilterOpen;
    },
    "Custom/RMA/ClearParameter": (draft: Draft<RMAHistoryState>) => {
        draft.RMACollectionParams = {
            ...initialState.RMACollectionParams,
        };
    },
    "Custom/RMA/BeginLoadRMADetailsCollection": (draft: Draft<RMAHistoryState>) => {
        draft.isLoading = true;
        draft.RMACollectionDetails = null;
        draft.RMACollectionMessages = null;
    },
    "Custom/RMA/CompleteLoadRMADetailsCollection": (
        draft: Draft<RMAHistoryState>,
        action: { result: RMADetailsResult },
    ) => {
        draft.isLoading = false;
        draft.RMACollectionDetails = action.result;
    },
    "Custom/RMA/CompleteLoadRMAMessages": (
        draft: Draft<RMAHistoryState>,
        action: { collection: MessageCollectionModel[] },
    ) => {
        draft.isLoading = false;
        draft.RMACollectionMessages = action.collection;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
